import * as roles from "../../catalogs/roles";

/*
EXAMPLE OF SECTION AVAILABLE ONLY FOR SPECIFIC USERS
{
    key: "BIDashboards/Sarona",
    label: "Loan Portfolio Dashboard",
    users: ["sarona@sarona.com"], //User specific items must should not include 'roles' property
    leftIcon: "fas fa-tachometer-alt"
  },
*/

/*
IMPORTANT - HOW TO CONFIGURE
Sidebar menu options must contain key, label, leftIcon and roles. users is optional.
Roles should contain one or more of the allowed roles.
Users could contain one or more emails. If users value is set, only the specified users will see the option in the menue.
*/

const options = [
  {
    key: "home",
    label: "Home",
    roles: [roles.AZET],
    leftIcon: "fas fa-home"
  },
  // {
  //   key: "BIDashboards/CovenantBreachesAnalysis",
  //   label: "Covenant Breaches Analysis",
  //   roles: [roles.AZET],
  //   leftIcon: "fas fa-tachometer-alt"
  // },
  {
    key: "BIDashboards/Investment",
    label: "Debt Facility Analysis",
    roles: [roles.AZET],
    leftIcon: "fas fa-tachometer-alt"
  },
  // {
  //   key: "BIDashboards/ServicingReport",
  //   label: "Servicing Report",
  //   roles: [roles.AZET],
  //   leftIcon: "fas fa-tachometer-alt"
  // },
  {
    key: "BIDashboards/LoansWeeklyReconciliation",
    label: "Loans Weekly Reconciliation",
    roles: [roles.AZET],
    leftIcon: "fas fa-tachometer-alt"
  },
  {
    key: "BIDashboards/PortfolioReport",
    label: "Portfolio Report",
    roles: [roles.AZET],
    leftIcon: "fas fa-tachometer-alt"
  },
  {
    key: "BIDashboards/RiskAnalysis",
    label: "Loan Portfolio Analysis",
    roles: [roles.AZET],
    leftIcon: "fas fa-tachometer-alt"
  },
  // {
  //   key: "AdvanceRequests/AdvanceRequests",
  //   label: "Advance Requests",
  //   roles: [roles.AZET],
  //   leftIcon: "fas fa-table",
  // },
  // {
  //   key: "Invoices/Invoices",
  //   label: "Invoices",
  //   roles: [roles.AZET],
  //   leftIcon: "fas fa-table",
  // },
  // {
  //   key: "LoanSchedules/LoanSchedules",
  //   label: "Loan Schedule",
  //   roles: [roles.AZET],
  //   leftIcon: "fas fa-table",
  // },
  // {
  //   key: "LoanTapes",
  //   label: "Loan Tapes",
  //   roles: [roles.AZET],
  //   leftIcon: "fas fa-table",
  // },
  // {
  //   key: "Waivers/Waivers",
  //   label: "Waivers",
  //   roles: [roles.AZET],
  //   leftIcon: "fas fa-table",
  // },    
  {
    key: "backOffice",
    label: "Back Office",
    roles: [roles.AZET],
    leftIcon: "fas fa-users-cog",
    children: [
      // {
      //   key: "BackOffice/ApprovalRequest",
      //   label: "Approval Request"
      // },
      {
        key: "BackOffice/AccountMovements",
        label: "Bank Account Movements"
      },
      {
        key: "BackOffice/Accounts",
        label: "Bank Account Statements"
      },
      // {
      //   key: "BackOffice/CovenantWaivers",
      //   label: "Covenant Waivers",
      // },
      // {
      //   key: "BackOffice/Datasets",
      //   label: "Datasets"
      // },
      {
        key: "BackOffice/Facilities",
        label: "Facilities"
      },
      {
        key: "BackOffice/FacilityDocuments",
        label: "Facility Reporting"
      },
      // {
      //   key: "BackOffice/FacilityMarkToMarketHedge",
      //   label: "Mark To Market Hedge"
      // },
      {
        key: "BackOffice/PartnerDocuments",
        label: "Partner Reporting"
      },
      {
        key: "BackOffice/Partners",
        label: "Partners"
      },
      // {
      //   key: "BackOffice/PaymentDeletionRequests",
      //   label: "Payment Deletion"
      // },
      // {
      //   key: "BackOffice/PledgedLoans",
      //   label: "Pledged Loans"
      // },
      // {
      //   key: "BackOffice/UserManuals",
      //   label: "User Manuals"
      // }
    ]
  },
  {
    key: "manage",
    label: "Manage",
    roles: [roles.ADMINISTRATOR],
    leftIcon: "fas fa-tools",
    children: [
      {
        key: "Signup/Signup",
        label: "Create User"
      }
    ]
  }
];
export default options;
